import Crud from '../views/Departamento/Crud'
import Entity from '../views/Departamento/Add'

let routes = {
    path: '/departamentos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/departamentos/add',
            name: 'NewDepartamento',
            component: Entity
        },
        {
            path: '/departamentos/edit/:id?',
            name: 'EditDepartamento',
            component: Entity
        },
        {
            path: '/departamentos',
            name: 'list-departamentos',
            component: Crud,
            meta: {
                pageTitle: '',
                breadcrumb: [
                    {
                        text: 'Departamentos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
